<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M17.768 3.5H11.168C9.51111 3.5 8.16797 4.84315 8.16797 6.5V21.5C8.16797 23.1569 9.51111 24.5 11.168 24.5H17.768C19.4248 24.5 20.768 23.1569 20.768 21.5V6.5C20.768 4.84315 19.4248 3.5 17.768 3.5Z"
			:fill="props.iconColor"
		/>
		<path d="M13.418 22.4H15.518" stroke="#C6C6D6" stroke-width="2" stroke-linecap="round" />
	</svg>
</template>

<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 34,
		height: 34,
		iconColor: '#ffff',
	}
);
</script>

<style lang="scss" scoped></style>
